import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import HomeCategorieDetails from "../../../Components/Modal/supplier_app/HomeIntro/HomeCategorieDetails";

//Redux
import { useSelector } from "react-redux"; //useDispatch
import "./homeIntro.scss";
import CategoryCard from "../../../Components/Cards/CategoryCard";
import StatusDonutChartCard from "../../../Components/Cards/StatusDonutChart";
import StatsGrid from "../../../Components/Cards/StatsGrid";
import HorizontalBarChart from "../../../Components/HorizontalBarChart/HorizontalBarChart";
import ItemService from "../../../services/supplier_appCommonService";
import SupplierConstants from "../../../common/SupplierConstants";
import {
  Boxes,
  ClipboardList,
  PackageSearch,
  TruckIcon,
  Warehouse,
} from "lucide-react";
import {
  ArrowRightEndOnRectangleIcon,
  ChartBarSquareIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentListIcon,
  CurrencyDollarIcon,
  DocumentCheckIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import HomeIntorVideo from "../../../Components/Modal/supplier_app/HomeIntro/HomeIntorVideo";
import ItemService3 from "../../../services/ap_auto_appCommonService";
import CollapseCard from "../../../Components/Collapsecard/Collapsecard";
const HomeIntro = () => {
  const currentDate = new Date();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Home");
  localStorage.setItem("submenu", "-");
  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  const firstName = userData?.firstName || "User";

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) return "Good Morning";
    if (hour >= 12 && hour < 17) return "Good Afternoon";
    if (hour >= 17 && hour < 21) return "Good Evening";
    return "Good Night";
  };
  // eslint-disable-next-line no-unused-vars
  const [totalPostDispatchCountStatus, setTotalPostDispatchCountStatus] =
    useState(false);

  const [productdata, setProductdata] = useState({});
  useEffect(() => {
    setProductdata(appConfig?.homeIntro);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appConfig]);

  // Format the date (optional)
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  // const [getIntroVideo, setIntroVideo] = useState(false);
  const [getCategoryDetail, setCategoryDetail] = useState(false);

  const [getVideoPath, setVideoPath] = useState();

  const [getIntroVideo, setIntroVideo] = useState(false);
  const introVideoShow = (getVideoPath) => {
    setIntroVideo(true);
    setVideoPath(getVideoPath);
  };

  const introVideoHide = () => {
    setIntroVideo(false);
  };

  let purchaseOrderData = useSelector(
    (state) => state?.purchasing?.purchase_order,
  ); // get purchaseOrderData from Store

  const loadInitialPOData = async () => {
    setData(purchaseOrderData?.data);
  };

  useEffect(() => {
    loadInitialPOData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseOrderData]);

  // eslint-disable-next-line
  const [data, setData] = useState([]);

  const [moduleStats, setModuleStats] = useState({});
  const [loadingStats, setLoadingStats] = useState(true);

  const loadModuleStats = async () => {
    try {
      setLoadingStats(true);
      const payload = {
        dashboard: "warehouse",
        chartFilterType: "Yearly",
        chartInput2: new Date().getFullYear(),
      };
      const res = await ItemService3.getModuleStats(payload); // use your actual service method
      if (res?.status === 200) {
        setModuleStats(res?.data);
      }
    } catch (err) {
      console.log("Failed to load module stats", err);
    } finally {
      setLoadingStats(false);
    }
  };

  useEffect(() => {
    loadModuleStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (moduleStats?.customer_cust_count?.chartData) {
      const customerData = moduleStats.customer_cust_count.chartData.map(
        (item) => ({
          name: item.status || "Unknown",
          count: item.count,
        }),
      );

      setStatusCountData(customerData);
    }
  }, [moduleStats]);
  const categoryConfigs = [
    {
      title: "Stocks",
      icon: Boxes, // Inventory/stock items
      directCount: moduleStats?.stocks?.total ?? 0,
      navigateKey: "pr",
    },
    {
      title: "Warehouse",
      icon: Warehouse, // Warehouse building
      directCount: moduleStats?.warehouse?.total ?? 0,
      navigateKey: "qtn",
    },
    {
      title: "Material",
      icon: PackageSearch, // Materials/products
      directCount: moduleStats?.material?.total ?? 0,
      navigateKey: "po",
    },
    {
      title: "Material Indent",
      icon: ClipboardList, // Indent/request form
      directCount: moduleStats?.MaterialIndent?.total ?? 0,
      navigateKey: "po",
    },
  ];
  const queryConfigs = [
    {
      queryName: "Get_RFX_Cancelled_Count_value",
      title: "RFQ Cancelled",
      icon: DocumentTextIcon,
      // change: "12",
    },
    {
      queryName: "Get_Quotation_Count_value",
      title: "Request Quotation",
      icon: ClipboardDocumentListIcon,
      // change: "12",
    },
    {
      queryName: "Get_RFXTE_Count_value",
      title: "Technical Evaluation",
      // change: "12",
      icon: ChartBarSquareIcon,
    },
    {
      queryName: "Get_RFXCE_Count_value",
      title: "Commercial Evaluation",
      icon: CurrencyDollarIcon,
      // change: "12",
    },
    {
      queryName: "Get_ASN_Count_value",
      title: "Advanced Shipping Notice",
      icon: TruckIcon,
      // change: "12",
    },
    {
      queryName: "Get_GRN_Count_value",
      title: "Goods Received Note",
      icon: DocumentCheckIcon,
      // change: "12",
    },
    {
      queryName: "Get_PR_Count_value",
      title: "Service Entry Sheet",
      icon: ClipboardDocumentCheckIcon,
      // change: "12",
    },
    {
      queryName: "Get_Gatepass_Count_value",
      title: "Gate Entry",
      icon: ArrowRightEndOnRectangleIcon,
      // change: "12",
    },
  ];

  const navigateToMainPage = (page) => {
    if (page === "supplier") {
      navigate(SupplierConstants.SUPPILER_LIST);
    } else if (page === "qtn") {
      navigate(SupplierConstants.SOURCING_BUYER_QUOTATION_LIST);
    } else if (page === "pr") {
      navigate(SupplierConstants.SOURCING_PURCHASE_REQUISITION_LIST);
    } else if (page === "po") {
      navigate(SupplierConstants.POCOLLABRATION_PURCHASE_ORDER_LIST);
    } else if (page === "tnd") {
      navigate(SupplierConstants.TENDER_LIST);
    } else if (page === "product") {
      navigate(SupplierConstants.SHOW_WISE_CATALOG);
    }
  };

  const [statusCountData, setStatusCountData] = useState([]);

  const loadTotalStatusCount = async () => {
    let obj = {
      queryName: "getSupplier_StatusChartList",
      chartCategory: "status",
    };
    try {
      await ItemService.generateChartQuery(obj).then((item) => {
        if (item?.status === 200) {
          setStatusCountData(item?.data);
        } else {
          console.error("Failed to Status Count");
        }
      });
    } catch (error) {
      console.log("Failed to Status Count", error);
    }
  };

  useEffect(() => {
    loadTotalStatusCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line no-unused-vars
  const categoryDetailShow = () => {
    // setCategoryDetail(true);
  };

  const categoryDetailHide = () => {
    setCategoryDetail(false);
  };

  const ProductSection = ({ data }) => {
    return (
      <Row className="homeintroposter">
        {/* Product Info Section */}
        <Col
          xs={12}
          md={12}
          lg={12}
          className="postertext d-flex justify-content-center align-items-center flex-column mb-4"
        >
          <p className="fw-bold ms-2 fs-3">{data?.mainTitle}</p>
          <div className="smarthub">
            <p className="fs-5 fw-bold ms-2">{data?.subTitle}</p>
          </div>
        </Col>
        {/* Loop through products */}

        {data?.products?.map((product, index) => (
          <Col
            key={index}
            xs={12}
            md={2}
            lg={2}
            className="d-flex flex-column align-items-center p-2"
          >
            <div className="image-box d-flex justify-content-center align-items-center">
              <img
                className="img-fluid"
                src={product?.image}
                alt={product?.alt}
              />
            </div>
            <p className="fs-5 fw-bold m-0">{product?.name}</p>
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <main className="dashboard main customer" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row className="home-intro">
              <Col xs={12} md={12} lg={12} className="headers p-2 mb-2">
                <Row className="align-items-center">
                  {/* LEFT SECTION */}
                  <Col xs={12} md={3}>
                    <h4 className="greeting">
                      <span className="morningText">{getGreeting()}</span>,{" "}
                      <span className="userName">{firstName}</span> 👋
                    </h4>
                    <h5 className="welcome">
                      Welcome to{" "}
                      <span className="portal">Factory Management</span>
                    </h5>
                  </Col>

                  {/* CENTER SECTION */}
                  <Col xs={12} md={7} className="text-center">
                    <div className="d-flex justify-content-center align-items-center">
                      {appConfig?.customerLogo1 && (
                        <img
                          className="img-fluid introCustomerlogo"
                          src={appConfig?.customerLogo1}
                          alt="logo1"
                        />
                      )}

                      <p className="fw-bold ms-2 fs-2 mb-0">
                        {appConfig?.customerName}
                      </p>

                      {appConfig?.customerLogo2 && (
                        <img
                          className="img-fluid ms-2"
                          src={appConfig?.customerLogo2}
                          alt="logo2"
                        />
                      )}
                    </div>
                  </Col>

                  {/* RIGHT SECTION (DATE AT END) */}
                  <Col xs={12} md={2} className="d-flex justify-content-end">
                    <div className="date">
                      <InputField
                        className="inputBox"
                        value={formattedDate}
                        disabled
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <div className="col-lg-12 px-0 mb-1">
                <CollapseCard title="">
                  {/* <h5 className="card-title mb-3">My Category</h5> */}
                  <div className="row g-3">
                    {categoryConfigs.map((item, index) => (
                      <div
                        className="col-12 col-md-6 col-lg-3 px-2 py-0"
                        key={index}
                      >
                        <CategoryCard
                          {...item}
                          loading={loadingStats}
                          onClick={() => navigateToMainPage(item.navigateKey)}
                        />
                      </div>
                    ))}
                  </div>
                </CollapseCard>
              </div>
              <div className="col-lg-12 px-0 mb-1">
                <CollapseCard title="">
                  <div className="row g-3 mt-0 align-items-start">
                    {/* LEFT DONUT CHART */}
                    <div className="col-12 col-lg-4 d-flex">
                      <StatusDonutChartCard
                        title="Supplier Statics"
                        data={statusCountData}
                        className="w-100 h-100"
                      />
                    </div>

                    {/* RIGHT STATS GRID */}
                    <div className="col-12 col-lg-8 d-flex">
                      <div className="card w-100 h-100">
                        <div className="card-body p-0">
                          <StatsGrid
                            queryConfigs={queryConfigs}
                            // refreshInterval={30000}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </CollapseCard>
              </div>
              <div className="col-lg-12 px-0 mb-1">
                <CollapseCard title="">
                  <div className="row g-3 mt-0 mb-2 align-items-stretch">
                    {/* Purchase Requisition */}
                    <div className="col-lg-6 col-md-6">
                      <div className="card h-100 dashboard-card-gap card-left">
                        <div className="card-body p-2">
                          <HorizontalBarChart
                            title="Purchase Requisition"
                            fetchFunction={async ({
                              page = 1,
                              per_page = 200,
                            }) =>
                              await ItemService.getPurchaseRequisition({
                                page,
                                per_page,
                              })
                            }
                            keyName="prStatusHeader"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Request For Quotation */}
                    <div className="col-lg-6 col-md-6">
                      <div className="card h-100 dashboard-card-gap">
                        <div className="card-body p-2">
                          <HorizontalBarChart
                            title="Request For Quotation"
                            fetchFunction={async ({
                              page = 1,
                              per_page = 200,
                            }) =>
                              await ItemService.getQuotation({
                                page,
                                per_page,
                              })
                            }
                            keyName="rfxHeaderStatus"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Purchase Order */}
                    <div className="col-lg-6 col-md-6">
                      <div className="card h-100 dashboard-card-gap card-left">
                        <div className="card-body p-2">
                          <HorizontalBarChart
                            title="Purchase Order"
                            data={purchaseOrderData?.data}
                            keyName="statusHeader"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Invoice */}
                    <div className="col-lg-6 col-md-6">
                      <div className="card h-100 dashboard-card-gap">
                        <div className="card-body p-2">
                          <HorizontalBarChart
                            title="Invoice"
                            fetchFunction={async ({
                              page = 1,
                              per_page = 200,
                            }) =>
                              await ItemService.getInvoiceList({
                                page,
                                per_page,
                              })
                            }
                            keyName="invoiceStatusHeader"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Tender */}
                    <div className="col-lg-6 col-md-6">
                      <div className="card h-100 dashboard-card-gap">
                        <div className="card-body p-2">
                          <HorizontalBarChart
                            title="Tender"
                            fetchFunction={async ({
                              page = 1,
                              per_page = 200,
                            }) =>
                              await ItemService.generateQueryV1({
                                queryName: "TenderDocumentList",
                                page,
                                per_page,
                              })
                            }
                            keyName="tenderHeaderStatus"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </CollapseCard>
              </div>
              <Col xs={12} md={12} lg={12} className="mb-2">
                <ProductSection data={productdata} />
              </Col>
              <Col xs={12} md={12} lg={12} className="headers mb-0 mt-0">
                <p className="title p-2">Process</p>
                <div className="d-flex overflow-auto mb-0 mt-0">
                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Vendor Management</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Procurement</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-file-earmark-check"></i>
                          </div>
                          <h5 className="card-title">Sourcing</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-card-list"></i>
                          </div>
                          <h5 className="card-title">Contract</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/vendor_management.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Auction</h5>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-2 commTopButtonRightLeftPadding">
                    <div
                      onClick={() =>
                        introVideoShow("./assets/videos/Spend_Analysis.mp4")
                      }
                      className="m-0 card info-card sales-card"
                    >
                      <div className="card-body">
                        <div className="d-flex align-items-center">
                          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                            <i className="bi bi-people-fill"></i>
                          </div>
                          <h5 className="card-title">Spend Analysis</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* <HomeIntorVideo show={getIntroVideo} onHide={introVideoHide} videopath={getVideoPath} /> */}
      <HomeCategorieDetails
        show={getCategoryDetail}
        onHide={categoryDetailHide}
      />
      <HomeIntorVideo
        show={getIntroVideo}
        onHide={introVideoHide}
        videopath={getVideoPath}
      />
    </main>
  );
};
export default HomeIntro;
